import { EditorState } from 'Wpds/components/rich-text';
import instance from './instance';
import { CommentParentType } from 'Shared/types/Comment.type';

type createCommentPayload = {
  goal_id?: string;
  reviews_slug?: string;
  body: string | EditorState;
};

export type CreateCommentParams = {
  record: CommentParentType;
  parentId: string;
  payload: createCommentPayload;
};

export const createComment = ({ record, parentId, payload }: CreateCommentParams) =>
  instance.post(`/${record === 'goal' ? 'goals' : 'reviews'}/${parentId}/comments`, payload);

export const deleteComment = slug => instance.delete(`/comments/${slug}`);

export const updateComment = data => instance.put(`/comments/${data.slug}`, data);
